import React, { useState } from 'react'
import { WContainer, Breadcrumbs, MainTitle } from '@next-nx/shared-ui/atoms'
import { CircleBox } from '@next-nx/shared-ui/molecules'
import { FaqHub, Page } from '@next-nx/shared-ui/organisms'
import { PaginaType, CategorieFaqDetailInterface, FaqInterface } from '@next-nx/utils/types'
import { useTrans } from '@next-nx/hooks'
import styles from './FaqTemplate.module.sass'

interface Props {
  pagina: PaginaType
  categorie: CategorieFaqDetailInterface[]
  faqsFrequenti: FaqInterface[]
}

const FaqTemplate = (props: Props) => {

  const { 
    pagina,
    categorie,
    faqsFrequenti
  } = props

  const t = useTrans()
  const [inputValue, setInputValue] = useState('')

  const handleOnSubmit = (e: any) => {
    if (!inputValue?.length) {
      e.preventDefault()
    }
  }


  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <WContainer>
        <Breadcrumbs breadcrumbs={pagina.breadcrumbs} className={styles.breadcrumbs} />
        <MainTitle label={pagina.titolo} className={styles.title} />
      </WContainer>
      <FaqHub 
        categorie={categorie}
        faqsFrequenti={faqsFrequenti} />
      <WContainer className={styles.custom_wcontainer}>
        <CircleBox
          variant='horizontal'
          animationVariant='vertical'
          item={{
            image: undefined,
            name: t('Cerchi un’assistenza immediata?'),
            description: t('Un nostro consulente sarà a tua disposizione per rispondere a tutte le tue domande.'),
            url: '/contattaci',
            ctaLabel: t('Contattaci')
          }} />
      </WContainer>
    </Page>
  )
}

export default FaqTemplate
